import type { TOC } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import GroupInviteSidebar from 'invite-sign/components/group-invite-sidebar';
import type { GroupInviteLinkShowRouteModel } from 'invite-sign/routes/group-invite/show';

interface GroupInviteShowComponentSignature {
  Args: {
    model: GroupInviteLinkShowRouteModel;
  };
}

const GroupInviteShowComponent = <template>
  <div class="h-screen md:flex items-center justify-center">
    <div class="md:rounded-lg md:flex md:shadow-md md:h-160">
      {{! Left side }}
      <div class="relative sidebar-background bg-center bg-cover pb-8 md:h-full md:w-77 md:rounded-l-lg md:pb-0">

        {{! Logo or company name }}
        <div class="flex content-center pt-10 text-center transition justify-center md:pt-31 md:px-13">
          {{#unless @model.location.hideLogo}}
            <div
              class="md:w-48 md:pt-0 md:mt-0 -mt-3 absolute transition flow z-10"
              style="height: 115px; display: flex; align-items: center; justify-content: center;"
            >
              {{#if @model.location.logoUrl}}
                <img
                  style="max-width: 190px; max-height: 85px"
                  data-test-logo-url
                  src={{@model.location.logoUrl}}
                  alt={{@model.location.companyName}}
                />
              {{else}}
                <div data-test-company-name class="text-4xl md:text-3xl pt-5 font-bold transition">
                  {{@model.location.companyName}}
                </div>
              {{/if}}
            </div>
          {{/unless}}
        </div>

        {{#if @model.groupInviteLink}}
          <GroupInviteSidebar @model={{@model.groupInviteLink}} @steps={{@model.steps}} />
        {{/if}}
      </div>

      {{! Right side }}
      <div
        class="bg-white overflow-y-auto p-6 pb-0 fast-transition relative md:mt-0 md:w-143 md:rounded-r-lg md:p-14 md:pt-12 md:pb-0"
      >
        {{outlet}}
      </div>
    </div>
  </div>
</template> satisfies TOC<GroupInviteShowComponentSignature>;

export default RouteTemplate<GroupInviteShowComponentSignature>(GroupInviteShowComponent);
